import usePrivateAxios from '@/common/api/usePrivateAxios'
import { unFormatCurrency } from '@/common/utils/unFormatters'
import { UpdatePersonalCardLimitsValidationSchema } from '@/features/privateCompanies/components/showUser/updatePersonalCardLimits/schema'
import { UseMutationResult, useMutation } from '@tanstack/react-query'

interface useUpdateCompanyUserPersonalCardLimitsOptions {
  userId?: string
  cardId?: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useUpdateCompanyUserPersonalCardLimits = ({
  userId,
  cardId,
  onSuccess,
  onError,
}: useUpdateCompanyUserPersonalCardLimitsOptions): UseMutationResult<
  void,
  Error,
  UpdatePersonalCardLimitsValidationSchema
> => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationFn: async (form: UpdatePersonalCardLimitsValidationSchema) => {
      await privateAxios.put(`/client/users/${userId}/update_card`, {
        client_card: {
          id: cardId,
          limit_per_transaction: form?.limitByTransaction && form?.limit_per_transaction && unFormatCurrency(form?.limit_per_transaction) > 0 ? unFormatCurrency(form?.limit_per_transaction) : null,
          limit_period_in_days: form?.limitByPeriod ? form?.limit_period_in_days?.value : 7,
          limit_per_period: form?.limitByPeriod && form?.limit_per_period && unFormatCurrency(form?.limit_per_period) > 0 ? unFormatCurrency(form?.limit_per_period) : null,
        }
      })
    },
    onSuccess,
    onError,
  })
}
